import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectSurgerySegments, selectShowInvalids } from '@store/order/selectors';
import { setSurgerySegment } from '@store/order/slice';
import SegmentsMap from '@pages/order/surgery-info/SegmentsMap';
import { SegmentsEnum } from '@pages/order/surgery-info/SegmentsEnum';



const SurgerySegments = () => {
	const { t } = useTranslation('forms');

	const surgerySegments = useSelector(selectSurgerySegments);
	const showInvalids = useSelector(selectShowInvalids);

	const dispatch = useDispatch();
	const handleSetSurgerySegment = (value: string) => dispatch(setSurgerySegment(value));

	const segmentsHasHead = surgerySegments && surgerySegments.some(x => x === SegmentsEnum.head);
	const segmentsHasHindpaw = surgerySegments && surgerySegments.some(x => x === SegmentsEnum.hindpaw);

	
	return (
		<div className='surgery-segments'>

			<label className='surgery-label'>
				{t('surgeryInfo.segments.sectionLabel') + ' '}<span>*</span> {showInvalids && (!surgerySegments || surgerySegments.length === 0) &&
					<p className='form-invalid'>{t('validation.requiredField')}</p>}
			</label>

			<p className='surgery-second-label'>{t('surgeryInfo.segments.text')}</p>

			<SegmentsMap
				selectedSegments={surgerySegments}
				onSegmentClick={handleSetSurgerySegment} />

			{segmentsHasHead && !segmentsHasHindpaw &&
				<div className='surgery-segments-warning'>
					<p>{t('surgeryInfo.segments.warnings.head')}</p>
					<p>{t('surgeryInfo.segments.warnings.sharedText')}</p>
				</div>}

			{segmentsHasHindpaw && !segmentsHasHead &&
				<div className='surgery-segments-warning'>
					<p>{t('surgeryInfo.segments.warnings.hindpaw')}</p>
					<p>{t('surgeryInfo.segments.warnings.sharedText')}</p>
				</div>}

			{segmentsHasHead && segmentsHasHindpaw &&
				<div className='surgery-segments-warning'>
					<p>{t('surgeryInfo.segments.warnings.headAndHindpaw')}</p>
					<p>{t('surgeryInfo.segments.warnings.sharedText')}</p>
				</div>}

		</div>
	);
};

export default SurgerySegments;